import { buildAction } from 'store/actions/actionCreator'

import { TOGGLE_REPORT_BUG_DIALOG } from './constants'

export const toggleReportBugDialog = buildAction(TOGGLE_REPORT_BUG_DIALOG)
